import React from "react";
import LegalLayout from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Cancellation & Refund Policy" seoKey="cancellation-refund-policy">
      <p>We aim to provide reliable and transparent services. This policy outlines how cancellations and refunds are handled at Gulfudaan.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Cancellations</h3>
      <p>GAMCA appointment cancellations are only accepted while the application status is "NEW". Once processing has started, cancellation may not be possible.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Refund Eligibility</h3>
      <p>Refunds are issued only if the service could not be delivered due to an error on our part. Processing fees already paid to third-party centers (GAMCA, VFS, etc.) are non-refundable.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Refund Timeline</h3>
      <p>Approved refunds are processed back to the original payment method within 7-10 business days via Razorpay.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">How to Request a Refund</h3>
      <p>Contact our support team at help@gulfudaan.com or WhatsApp +91 73143 44673 with your Application Number to request a cancellation or refund.</p>
    </LegalLayout>
  );
}
